import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { WorkspaceQuickAction } from '../../types/workspaceMenu';

const QuickIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.common.white,
  padding: 4,
  borderRadius: theme.shape.borderRadius,
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.12)',
  },
  '&.Mui-disabled': {
    color: 'rgba(255, 255, 255, 0.35)',
  },
}));

interface WorkspaceQuickToolbarProps {
  actions: WorkspaceQuickAction[];
}

const WorkspaceQuickToolbar: React.FC<WorkspaceQuickToolbarProps> = ({ actions }) => {
  if (actions.length === 0) return null;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.25,
        minWidth: 0,
        flexWrap: 'nowrap',
      }}
    >
      {actions.map((action) => (
        <Tooltip key={action.id} title={action.helpTooltip}>
          <span>
            <QuickIconButton
              aria-label={action.label}
              onClick={action.onClick}
              disabled={action.disabled}
              size="small"
            >
              {action.icon}
            </QuickIconButton>
          </span>
        </Tooltip>
      ))}
    </Box>
  );
};

export default WorkspaceQuickToolbar;
